import { render, staticRenderFns } from "./relic-create.vue?vue&type=template&id=26012472"
import script from "./relic-create.vue?vue&type=script&lang=js"
export * from "./relic-create.vue?vue&type=script&lang=js"
import style0 from "./relic-create.vue?vue&type=style&index=0&id=26012472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports